import * as XLSX from "xlsx";

export type DownloadTemplateParams = {
  fileName: string;
  columns: string[];
  sheetName: string;
};

export const downloadTemplate = (template: DownloadTemplateParams) => {
  const workBook = XLSX.utils.book_new();
  const workSheet = XLSX.utils.aoa_to_sheet([template.columns]);
  XLSX.utils.book_append_sheet(workBook, workSheet, template.sheetName);
  XLSX.writeFile(workBook, template.fileName);
};
